import { render } from "./ServizioTypeBadge.vue?vue&type=template&id=78a2a66e"
import script from "./ServizioTypeBadge.vue?vue&type=script&lang=js"
export * from "./ServizioTypeBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__